export default function FindingCommentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  editFindingCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Finding Note Added';
  vm.isExpanded = false;
  vm.canEditItem = vm.canEdit;
  vm.canDeleteItem = vm.canDelete;

  // Attach Event Handlers
  vm.handleEditFindingComment = _handleEditFindingComment;
  vm.handleDeleteFindingComment = _handleDeleteFindingComment;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditFindingComment($event) {
    amDataService.getFindingComment(vm.findingComment.findingCommentId).then(() => {
      ssDialogService.dialogs.auditTrail.editFindingCommentDialog = ssDialogService.alert(
        editFindingCommentDialog.getOptions($event, {
          findingId: vm.findingId,
          findingCommentId: vm.findingComment.findingCommentId,
          findingCommentText: vm.findingComment.text,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.editFindingCommentDialog);
    });
  }

  function _handleDeleteFindingComment($event) {
    ssDialogService.dialogs.auditTrail.deleteFindingCommentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Finding Note?',
        message: `Are you sure you want to delete Finding Note "${vm.findingComment.text}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteFindingCommentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.deleteFindingComment(vm.findingComment.findingCommentId)
      .then(() => {
        alerts.success('The Finding Note has been deleted successfully.');
        $rootScope.$broadcast('refreshAMFindingComments', { findingId: vm.findingComment.findingId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Finding Note.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteFindingCommentConfirmDialog);
  }
}

FindingCommentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'editFindingCommentDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
